import { List, Stack, useTheme } from '@mui/material';

import { NavSectionProps } from '../types';

import NavList from './NavList';
import { StyledSubheader } from './styles';
// ----------------------------------------------------------------------

export default function NavSectionVertical({ data, sx, ...other }: NavSectionProps) {
  const theme = useTheme();

  return (
    <Stack sx={sx} {...other}>
      {data.map((group) => {
        const key = group.items[0].title ?? 'header';

        return (
          <List
            key={key}
            disablePadding
            sx={{ p: 2, ml: 1, mr: 1, borderBottom: '1px solid ' + theme.palette.divider }}
          >
            {group.subheader && <StyledSubheader disableSticky>{group.subheader}</StyledSubheader>}

            {group.items.map((list, index) => (
              <NavList
                key={list.title + list.path}
                data={list}
                depth={1}
                hasChild={!!list.children}
                index={index}
              />
            ))}
          </List>
        );
      })}
    </Stack>
  );
}
